// Lib
import React from 'react';

// Components
import TaskAssignmentPanel from './assignment/TaskAssignmentPanel';
import TaskDueDatePanel from './assignment/dueDate/TaskDueDatePanel';

// Styles
import './TaskToolPanel.scss';

const TaskToolPanel = (props) => (
    <div className="TaskToolPanel">
        <TaskDueDatePanel {...props} />
        <TaskAssignmentPanel {...props} />
    </div>
);

export default TaskToolPanel;
